module.exports = __webpack_public_path__ + "img/icon_paper.5a54f6f1.png";